import { useSelector } from 'react-redux';
import { hasReadOnlyPrivilegesForCustomerData } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { TooltippedIconButton, useEnterpriseBuildLocation } from '@mews-commander/ui';
import { lt, useDialog } from '@mews/framework';
import { Dialog } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { TextKey } from '@mews-commander/enums';
import TemplateFetcher from '../../../../app/components/TemplateFetcher';

export const ClearAction = ({ customerId }: { customerId: string }) => {
    const [{ onClose: onClearDialogClose, active: isClearDialogActive }, toggleClearDialog] = useDialog();

    const readOnlyForm = useSelector(hasReadOnlyPrivilegesForCustomerData);

    const buildLocation = useEnterpriseBuildLocation();
    const url = buildLocation({ to: 'Customer/Clear/$id', params: { id: customerId } }).href;

    return (
        <>
            {!readOnlyForm && (
                <TooltippedIconButton
                    icon={IconName.Broom}
                    onClick={toggleClearDialog}
                    tooltip={lt(TextKey.Clear)}
                    type="button"
                />
            )}
            <Dialog
                title={lt(TextKey.ClearCustomerProfile)}
                active={isClearDialogActive}
                onClose={onClearDialogClose}
                size="medium"
            >
                <TemplateFetcher url={url} layout="Empty" />
            </Dialog>
        </>
    );
};
